export default __webpack_public_path__ + "locales/de/Article.json?hash=79dd6a2b3acc027635b51b61197ce4ff";